'use strict';

var variables = require('./variables-1eb6495a.js');

const light = {
    root: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        boxSizing: "content-box",
        height: "24px",
        padding: "12px 8px 12px 24px",
        fontSize: "16px",
        lineHeight: "24px",
        backgroundColor: variables.COLORS.GREYSCALE_98,
        borderBottom: `1px ${variables.COLORS.GREYSCALE_0_15} solid`,
    },
};

var MuiDialogTitle = /*#__PURE__*/Object.freeze({
  __proto__: null,
  light: light
});

exports.MuiDialogTitle = MuiDialogTitle;
exports.light = light;
